import {
  type ContentResource,
  type MessageStatusResource,
  type ParticipantTypeResource,
} from './api/resources/messages'
import { type TextContent } from './content'
import { type MessageDeliveryStatus } from './message-status'
import { type MessageType } from './message-type'
import { type ParticipantType } from './Participant'

/**
 * Maps a message's content type to the kind of message it is.
 */
export function mapMessageTypeResourceToMessageType(
  type: ContentResource['type'],
): MessageType {
  switch (type) {
    case 'NOTE':
    case 'TEAM_NOTE':
    case 'ADMIN_NOTE':
      return 'Note'
    case 'ADMIN':
      return 'AdminMessage'
    case 'SYSTEM':
      return 'SystemMessage'
    case 'EXTERNAL_REFERENCE':
      return 'ExternalReference'
    case 'TEXT':
    case 'FILE':
    case 'CALL':
      return 'Message'
  }
  // The API may send values this build doesn't know yet.
  return 'Message'
}

/**
 * Maps a recipient's delivery status.
 */
export function mapMessageStatusResourceToDeliveryStatus(
  status: MessageStatusResource['status'],
): MessageDeliveryStatus {
  switch (status) {
    case 'SENT':
      return 'Sent'
    case 'DELIVERED':
      return 'Delivered'
    case 'READ':
      return 'Read'
  }
  return 'None'
}

/**
 * Maps a participant's type.
 */
export function mapParticipantTypeResourceToType(
  type: ParticipantTypeResource,
): ParticipantType {
  switch (type) {
    case 'ADMIN':
      return 'Admin'
    case 'MEMBER':
      return 'Member'
  }
}

/**
 * Text shown for content we can't map to a richer type.
 */
export function createFallbackContent(text?: string): TextContent {
  return {
    type: 'Text',
    text: text || '_no message_',
  }
}
